import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import BankAccounts from "@/pages/admin/BankAccounts";
import { ArrowLeft } from "lucide-react";

export default function InstituteBanks() {
  const { instituteId } = useParams();
  const [institute, setInstitute] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/institutes/${instituteId}`);
        setInstitute(data);
      } catch (err) {
        setError(err?.response?.data?.detail || "Institute not found");
      } finally {
        setLoading(false);
      }
    })();
  }, [instituteId]);

  if (loading) {
    return (
      <div className="p-12 text-[#6b655b] font-serif text-xl">Loading institute…</div>
    );
  }

  if (error) {
    return (
      <div className="p-12 max-w-3xl mx-auto" data-testid="institute-not-found">
        <Link
          to="/admin/institutes"
          className="inline-flex items-center gap-2 text-sm text-[#234333] hover:underline"
        >
          <ArrowLeft size={14} strokeWidth={1.5} /> Back to institutes
        </Link>
        <div className="mt-6 bg-white border border-[#e5e0d8] rounded-sm p-10 text-center">
          <div className="font-serif text-2xl text-[#9e2a2b]">{error}</div>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="institute-banks-page">
      <div className="px-8 md:px-12 pt-8">
        <Link
          to="/admin/institutes"
          data-testid="institute-banks-back"
          className="inline-flex items-center gap-2 text-sm text-[#234333] hover:underline"
        >
          <ArrowLeft size={14} strokeWidth={1.5} /> Back to institutes
        </Link>
      </div>
      <BankAccounts
        apiBase={`/institutes/${instituteId}/banks`}
        title={`${institute.name} — Bank Accounts`}
        subtitle={`Institute · ${institute.code}`}
        intro="Accounts operated by this institute. Separate from the trust-level accounts."
        signatoryMode="mca"
      />
    </div>
  );
}
